import { Fail } from '@easeltv/fail';

import { ApiErrorResponse } from '../models';

export class ApiFail extends Fail {
    status?: number;

    response: ApiErrorResponse;

    constructor({ key, description, name, data, status }: ApiErrorResponse) {
        super({
            key,
            userMessage: name,
            data: {
                ...data,
                description,
            },
        });

        this.status = status;
        this.response = { key, description, name, data, status };
    }

    /**
     * toObject
     *
     * Converts the ApiFail class to an object
     *
     * @returns An error object
     */
    override toObject() {
        return Object.freeze({
            data: this.data,
            key: this.key,
            location: this.location,
            userMessage: this.userMessage,
            status: this.status,
        });
    }
}
